module.exports = __webpack_public_path__ + "static/img/抖音.e172fa71.png";